(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bday-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.od-gallery').forEach((gallery) => {
      // ---- Balanced masonry (shortest-column distribution) ----
      const masonry = gallery.querySelector('.od-gallery__masonry');
      if (masonry) {
        const items = Array.from(masonry.querySelectorAll('.od-gallery__item'));
        if (items.length) {
          const num = (v, d) => parseInt(getComputedStyle(gallery).getPropertyValue(v), 10) || d;
          const colCount = () => {
            const w = window.innerWidth;
            if (w <= 749) return num('--od-gallery-cols-mobile', 2);
            if (w <= 989) return num('--od-gallery-cols-tablet', 3);
            return num('--od-gallery-cols', 3);
          };
          const build = () => {
            const cols = colCount();
            masonry.classList.add('od-gallery__masonry--js');
            masonry.querySelectorAll('.od-gallery__col').forEach((c) => c.remove());
            const colEls = [];
            const heights = [];
            for (let i = 0; i < cols; i++) {
              const c = document.createElement('div');
              c.className = 'od-gallery__col';
              masonry.appendChild(c);
              colEls.push(c);
              heights.push(0);
            }
            items.forEach((item) => {
              let mi = 0;
              for (let i = 1; i < heights.length; i++) if (heights[i] < heights[mi]) mi = i;
              colEls[mi].appendChild(item);
              heights[mi] += item.offsetHeight + 1;
            });
          };
          build();
          window.addEventListener('load', build);
          items.forEach((it) => {
            const img = it.querySelector('img');
            if (img && !img.complete) img.addEventListener('load', build, { once: true });
          });
          let rt;
          window.addEventListener('resize', () => {
            clearTimeout(rt);
            rt = setTimeout(build, 150);
          });
        }
      }

      // ---- Lightbox ----
      const lightbox = gallery.querySelector('[data-gallery-lightbox]');
      const lightboxImg = gallery.querySelector('[data-gallery-lightbox-img]');
      const closeBtn = gallery.querySelector('[data-gallery-close]');
      if (lightbox && lightboxImg) {
        const open = (src, alt) => {
          lightboxImg.src = src;
          lightboxImg.alt = alt || '';
          lightbox.hidden = false;
          document.body.style.overflow = 'hidden';
        };
        const close = () => {
          lightbox.hidden = true;
          lightboxImg.src = '';
          document.body.style.overflow = '';
        };
        gallery.querySelectorAll('[data-gallery-zoom]').forEach((item) => {
          item.addEventListener('click', () => {
            const img = item.querySelector('img');
            const full = item.getAttribute('data-full') || (img && (img.currentSrc || img.src));
            if (full) open(full, img ? img.alt : '');
          });
        });
        if (closeBtn) closeBtn.addEventListener('click', close);
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox) close();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && !lightbox.hidden) close();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bday-journey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.section-bday-journey').forEach((sec) => {
      const grid = sec.querySelector('.od-birthday-raffle__journey-grid--mobile-slider');
      const nav = sec.querySelector('.od-birthday-raffle__slider-nav');
      if (!grid || !nav) return;
      const amount = () => grid.clientWidth * 0.64;
      const prev = nav.querySelector('[data-slider-prev]');
      const next = nav.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => grid.scrollBy({ left: -amount(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => grid.scrollBy({ left: amount(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bday-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.section-bday-steps').forEach((sec) => {
      const grid = sec.querySelector('.od-birthday-raffle__steps-grid--mobile-slider');
      const nav = sec.querySelector('.od-birthday-raffle__slider-nav');
      if (!grid || !nav) return;
      const amount = () => grid.clientWidth * 0.82;
      const prev = nav.querySelector('[data-slider-prev]');
      const next = nav.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => grid.scrollBy({ left: -amount(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => grid.scrollBy({ left: amount(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coming-soon-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-coming-soon]');

    sections.forEach((section) => {
      const timer = section.querySelector('[data-coming-soon-timer]');
      if (!timer) return;

      const targetDate = section.dataset.targetDate;
      const expiredText = section.dataset.expiredText || '00d 00h 00m 00s';
      const daySuffix = section.dataset.daySuffix || 'd';
      const hourSuffix = section.dataset.hourSuffix || 'h';
      const minuteSuffix = section.dataset.minuteSuffix || 'm';
      const secondSuffix = section.dataset.secondSuffix || 's';
      const targetTime = Date.parse(targetDate);

      if (!targetDate || Number.isNaN(targetTime)) {
        timer.textContent = expiredText;
        return;
      }

      const renderCountdown = () => {
        const diff = targetTime - Date.now();

        if (diff <= 0) {
          timer.textContent = expiredText;
          return;
        }

        const days = String(Math.floor(diff / 86400000)).padStart(2, '0');
        const hours = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
        const minutes = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
        const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');

        timer.textContent = `${days}${daySuffix} ${hours}${hourSuffix} ${minutes}${minuteSuffix} ${seconds}${secondSuffix}`;
      };

      renderCountdown();
      window.setInterval(renderCountdown, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.querySelectorAll('[data-password-launch]').forEach((section) => {
    if (section.dataset.enhanced === 'true') return;
    section.dataset.enhanced = 'true';

    const countdown = section.querySelector('[data-password-countdown]');
    const glitchItems = section.querySelectorAll('[data-glitch-text]');
    const targetValue = section.dataset.target;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const syncGlitchText = (element) => {
      if (!element) return;
      element.setAttribute('data-text', element.textContent.trim());
    };

    const setCountdownText = (value) => {
      if (!countdown) return;
      countdown.textContent = value;
      countdown.setAttribute('data-text', value);
    };

    if (countdown) {
      const fallback = countdown.dataset.expiredText !== undefined ? countdown.dataset.expiredText : '';
      const targetTime = Date.parse(targetValue);

      if (Number.isNaN(targetTime)) {
        setCountdownText(fallback);
      } else {
        const updateCountdown = () => {
          const diff = targetTime - Date.now();

          if (diff <= 0) {
            setCountdownText(fallback);
            window.clearInterval(section.passwordCountdownInterval);
            return;
          }

          const days = String(Math.floor(diff / 86400000)).padStart(2, '0');
          const hours = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
          const minutes = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
          const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');

          setCountdownText(`${days}d ${hours}h ${minutes}m ${seconds}s`);
        };

        updateCountdown();
        section.passwordCountdownInterval = window.setInterval(updateCountdown, 1000);
      }
    }

    glitchItems.forEach((item) => syncGlitchText(item));

    if (!reducedMotion && glitchItems.length) {
      const runGlitch = () => {
        glitchItems.forEach((item) => {
          syncGlitchText(item);
          item.classList.add('is-glitching');
        });

        const activeDuration = 180 + Math.floor(Math.random() * 240);
        const idleDuration = 2600 + Math.floor(Math.random() * 4200);

        window.setTimeout(() => {
          glitchItems.forEach((item) => item.classList.remove('is-glitching'));
          section.passwordGlitchTimeout = window.setTimeout(runGlitch, idleDuration);
        }, activeDuration);
      };

      section.passwordGlitchTimeout = window.setTimeout(runGlitch, 1200);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stars-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.stars-pdp').forEach((pdp) => {
      const gallery = pdp.querySelector('[data-stars-gallery]');
      if (gallery) {
        const mainImg = gallery.querySelector('[data-main-img]');
        const thumbs = gallery.querySelectorAll('[data-thumb]');
        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const full = thumb.getAttribute('data-full');
            if (mainImg && full) mainImg.src = full;
            thumbs.forEach((t) => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          });
        });
      }

      const qty = pdp.querySelector('[data-qty]');
      if (qty) {
        const input = qty.querySelector('[data-qty-input]');
        const clamp = () => {
          let v = parseInt(input.value, 10);
          if (isNaN(v) || v < 1) v = 1;
          input.value = v;
        };
        qty.querySelector('[data-qty-minus]').addEventListener('click', () => {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
        qty.querySelector('[data-qty-plus]').addEventListener('click', () => {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
        input.addEventListener('change', clamp);
      }

      const terms = pdp.querySelector('[data-terms]');
      const addBtn = pdp.querySelector('.stars-pdp__add');
      if (terms && addBtn) {
        addBtn.addEventListener('click', (e) => {
          if (!terms.checked) {
            e.preventDefault();
            e.stopImmediatePropagation();
            terms.reportValidity();
          }
        }, true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
